// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__2WLwW","title":"InfoRow_title__Ah0K4"};